var sidebar = (function() {
"use strict";

	// Set equal height on sidebar & main col
	var sidebar = $('.sidebar'),
		mainCol = sidebar.prev();

	$(window).on("load", function() {
		if (mainCol.height() > sidebar.height()) {
			sidebar.height(mainCol.height());
		}
	});
})();